<template>
  <div v-if="isInLandscapeMode" class="view-rotate">
    <div class="view-rotate__inner">
      <Icon icon="rotate-phone" />
      <h2 class="view-rotate__headline">{{ $t('status.rotateDevice.headline') }}</h2>
      <p>{{ $t('status.rotateDevice.copy') }}</p>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import Icon from './Icon';

function useLandscapeMode() {
  if (!window) return;

  const state = Vue.observable({
    isInLandscapeMode: false,
  });

  const checkOrientation = () => {
    if (
      window.matchMedia('(orientation: portrait)').matches &&
      window.innerWidth < 768 // only small devices
    ) {
      state.isInLandscapeMode = true;
    }
    if (window.matchMedia('(orientation: landscape)').matches) {
      state.isInLandscapeMode = false;
    }
  };

  window.addEventListener('orientationchange', checkOrientation, false);

  return () => state.isInLandscapeMode;
}

export default {
  name: 'ViewRotate',

  components: { Icon },

  computed: {
    isInLandscapeMode: useLandscapeMode(),
  },
};
</script>

<style lang="scss" scoped>
.view-rotate {
  background-color: rgba($color-black, $view-overlay-alpha-dark);
}

.view-rotate__inner {
  text-align: center;
  position: absolute;
  left: 50%;
  top: 50%;
  width: 100%;
  padding: 20px;
  transform: translate(-50%, -50%);
}

.view-rotate__icon {
  max-width: 100%;
}

.view-rotate__headline {
  padding-bottom: 10px;
}
</style>
